export default __webpack_public_path__ + "static/media/not-sure.f60b9b76.png";